import getDefaultUserAgent from '../get-default-user-agent';

const androidReg = /android/i;
const iosReg = /iPad|iPhone|iPod/;

export type MobileOS = 'Android' | 'iOS' | 'unknown';

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', or 'unknown'.
 */
export function getMobileOperationSystem(userAgent?: string): MobileOS {
  const agent = userAgent || getDefaultUserAgent();

  if (typeof agent !== 'string') {
    return 'unknown';
  }

  if (androidReg.test(agent)) {
    return 'Android';
  }

  if (iosReg.test(agent)) {
    return 'iOS';
  }

  return 'unknown';
}
